import DA from '@agora/data-analysis'
interface EventType {
  event_category: string
  event_label?: string
  value?: number
}

export const gtag: (type: 'event' | 'config' | 'get' | 'set', action: string, params: EventType) => void =
  window['gtag'] || function () {}

export const ga = (name: 'event' | 'config' | 'get' | 'set', label: string, options?: any) => {
  const hostname = document.location.hostname
  switch (hostname) {
    case 't.agoralab.co': {
      gtag(name, label, options)
      DA.event({
        event: label,
        category: options?.event_category,
        event_label: options?.event_label,
        event_value: options.value,
      })
      break
    }
    case 'tale-staging.agoralab.co': {
      gtag(name, label, Object.assign({}, options, { traffic_type: 'internal' }))
      DA.event({
        event: label,
        category: options?.event_category,
        event_label: options?.event_label,
        event_value: options.value,
      })
      break
    }
    default: {
      gtag(name, label, Object.assign({}, options, { debug_mode: true }))
      DA.event({
        event: label,
        category: options?.event_category,
        event_label: options?.event_label,
        event_value: options.value,
      })
    }
  }
}

export const traceEvent = {
  // tale_profile
  profile: {
    event_category: 'tale_profile',
    events: {
      show_page_profile: 'show_page_profile',
      click_upsert_about_me: 'click_upsert_about_me',
      click_add_skills: 'click_add_skills',
      click_add_hobbies: 'click_add_hobbies',
      click_upsert_career: 'click_upsert_career',
      click_upsert_education: 'click_upsert_education',
    },
  },

  // tale_onboarding
  onboarding: {
    event_category: 'tale_onboarding',
    events: {
      click_start: 'click_start',
      click_next_page: 'click_next_page',
      click_prev_page: 'click_prev_page',
      expose_time_page: 'expose_time_page',
    },
  },

  // anniversary-card
  anniversaryCard: {
    event_category: 'tale_anniversary_card',
    events: {
      show_card: 'show_card',
      expose_time_card: 'expose_time_card',
    },
  },
}
